import {white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    appBar: {
        position: 'fixed',
        top: 0,
        overflow: 'hidden',
        maxHeight: 57
    },
    menuButton: {
        float: "left"
    },
    iconsRightContainer: {
        marginLeft: 20,
        zIndex: 10000
    },
    presentation: {
        container: {
            height: "46px",
            marginLeft: 30,
            lineHeight: "46px",
            textAlign: "center",
            fontSize: 19,
            color: white,
            fontWeight: typography.fontWeightNormal
        },
        logo: {
            float: "left",
            height: "100%",
        },
        span: {
            marginLeft: 10
        }
    }
};
export default styles;



// WEBPACK FOOTER //
// src/components/common/Header/Header.css.js